module.exports = __webpack_public_path__ + "img/GUERIN.c4600543.gif";